import { render, staticRenderFns } from "./ProductMaterialCostDetailTemp.vue?vue&type=template&id=33fef632&"
import script from "./ProductMaterialCostDetailTemp.vue?vue&type=script&lang=js&"
export * from "./ProductMaterialCostDetailTemp.vue?vue&type=script&lang=js&"
import style0 from "./ProductMaterialCostDetailTemp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports